import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { fetchFamilyGroups } from '@gn-audio/core/api/product-catalogue/fetch-family-groups';
import { IGroup } from '@gn-audio/core/api/product-catalogue/models/group';
import { AvailabilityState } from '@gn-audio/core/common/enums';
import { Injectable } from 'angular-ts-decorators';
import { fetchGroupPrices } from '@gn-audio/core/api/pricing/fetch-group-prices';

@Injectable('buyButtonService')
export class BuyButtonService {
  public static $inject: ReadonlyArray<string> = [];

  /**
   * Calculates availability state of family based on availability states of it's groups
   * @param familyId Unique family ID
   * @async
   */
  public async getButtonState(familyId: number): Promise<AvailabilityState> {
    const familyGroups: IGroup[] = await fetchFamilyGroups(familyId);
    const groupIds: number[] = familyGroups.map((x: IGroup) => x.groupId);
    const groupPrices: (IFromPrice | ISFCCGroupPrice)[] = (await fetchGroupPrices(groupIds)) || [];
    const availabilityStates: AvailabilityState[] = groupPrices.map((x: IFromPrice | ISFCCGroupPrice) => x.availabilityState);

    // 'if' statements are ordered by priority (defines which state will be shown)
    if (availabilityStates.some((x: AvailabilityState) => x === AvailabilityState.Add)) {
      return AvailabilityState.Add;
    }

    if (availabilityStates.some((x: AvailabilityState) => x === AvailabilityState.PreOrder)) {
      return AvailabilityState.PreOrder;
    }

    if (availabilityStates.every((x: AvailabilityState) => x === AvailabilityState.ComingSoon)) {
      return AvailabilityState.ComingSoon;
    }

    if (availabilityStates.every((x: AvailabilityState) => x === AvailabilityState.WhereToBuy)) {
      return AvailabilityState.WhereToBuy;
    }

    if (availabilityStates.every((x: AvailabilityState) => x === AvailabilityState.BackOrder)) {
      return AvailabilityState.BackOrder;
    }

    return AvailabilityState.Add;
  }
}
